export default __webpack_public_path__ + "94254f1317cf9131a2225acc977051b4.png";